module.exports = __webpack_public_path__ + "img/ENT_Course_5.efd3fcaa.jpg";